<template>
  <div class="Equipment-Expenses-Drill-Through-Main">
     <!-- Top bar showing filter selections -->
    <div class="filtered-section">
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title-long">Date</div>
            <div class="colon-seperator">:</div>
            <div class="filter-details">{{this.injectedFromDate}} to {{this.injectedToDate}}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title-long">Equipment Category</div>
            <div class="colon-seperator">:</div>
            <div class="filter-details">{{this.filteredEquipmentCategory}}</div>
          </div>
        </div>
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title">Team</div>
            <div class="colon-seperator">:</div>
            <div class="filter-details">{{this.filteredTeam}}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">Workshop</div>
            <div class="colon-seperator">:</div>
            <div class="filter-details">{{this.filteredWorkshop}}</div>
          </div>
        </div>
        <div class="refresh-section">
          <div>Last Refreshed : {{this.lastRefreshed}}</div>
        </div>
      </div>  
    <div class="drill-through-body" id="drill-through-body">
      <TableBox v-if="pageLoaded" :title="tableTitle" apiEndpoint="GetEMSExpenses" :apiPayload="payload" :dataType="columnType"/>
      <TableBox v-if="showTableBox" :title="tableTitle" :tableData="drillThroughDetails" :dataType="columnType"/> 
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {
  },
  data: function() {
    return {
      // Value
      injectedFromDate: '',
      injectedToDate: '',
      injectedEquipmentCategory: '',
      injectedTeam: '',
      injectedWorkshop: '',
      filteredEquipmentCategory: '',
      filteredTeam: '',
      filteredWorkshop: '',

      // Last refresh time
      lastRefreshed: null,

      // Drill Through
      drillThroughDetails: [], 
      tableTitle: '',
      columnType: {},
      payload: {},
      showTableBox: false,

      // For Drill through with Pagination 
      pageLoaded: false,
    }
  },
  props: {
  },
  methods: {
    // Get item from Session Storage
    getAllFromStorage: async function() {
      var details = JSON.parse(sessionStorage.getItem(this.$route.params.drillThroughName));

      this.filteredEquipmentCategory = details.filteredEquipmentCategory;
      this.filteredTeam = details.filteredTeam;
      this.filteredWorkshop = details.filteredWorkshop;

      this.injectedFromDate = details.injectedFromDate;
      this.injectedToDate = details.injectedToDate;
      this.injectedEquipmentCategory = details.injectedEquipmentCategory;
      this.injectedTeam = details.injectedTeam;
      this.injectedWorkshop = details.injectedWorkshop;

      this.lastRefreshed = details.lastRefreshed;
      this.tableTitle = details.title;

      // for Expenses by Equipment Drill through 
      this.payload = details.data;
      
      console.log(this.payload);
    },
    drillThroughGenerate: async function() {
     if(this.tableTitle.includes('Top 30 Part Group Expenses')) {
      this.drillThroughDetails = await this.$apiCallV2(`/EquipmentExpenses/GetEMSExpenses?startdate=${this.injectedFromDate}&enddate=${this.injectedToDate}&teamarray=${this.injectedTeam}&categoryarray=${this.injectedEquipmentCategory}&workshoparray=${this.injectedWorkshop}&rpttype=BY_PARTGROUP&showtopx=30`);

      this.columnType = {
        '#' : 'number',
        'Amount' : 'currency',
        'Ranking' : 'number'
      }

      this.showTableBox = true;
     }
     else if(this.tableTitle.includes('Expenses by Part Type Summary')) {
      this.drillThroughDetails = await this.$apiCallV2(`/EquipmentExpenses/GetEMSExpenses?startdate=${this.injectedFromDate}&enddate=${this.injectedToDate}&teamarray=${this.injectedTeam}&categoryarray=${this.injectedEquipmentCategory}&workshoparray=${this.injectedWorkshop}&rpttype=PARTGROUP_DETAILS`);

      this.columnType = {
        '#' : 'number',
        'Amount' : 'currency'
      }

      this.showTableBox = true;
     }
     else if(this.tableTitle.includes('Expenses by Equipment Summary')) {
      this.drillThroughDetails = await this.$apiCallV2(`/EquipmentExpenses/GetEMSExpenses?startdate=${this.injectedFromDate}&enddate=${this.injectedToDate}&teamarray=${this.injectedTeam}&categoryarray=${this.injectedEquipmentCategory}&workshoparray=${this.injectedWorkshop}&rpttype=BY_EQUIPMENT`);

      this.columnType = {
        '#' : 'number',
        'Amount' : 'currency',
      }

      this.showTableBox = true;
     }
     else if(this.tableTitle.includes('Expenses by Equipment Details')) {
    
      this.columnType = {
        '#' : 'number',
        'Amount' : 'currency',
        'JobDate' : 'date',
      }

      this.pageLoaded = true;
     }

     this.$fullscreenLoading();
    },
  },
  async mounted() {
    this.$fullscreenLoading('Getting Drill Through Report');

    // Get items from storage session
    await this.getAllFromStorage();

    // Set tablebox height dynamically 
    var setTabulatorHeight = 'calc(' + '100%' + '-' + $("#filtered-section").height() + 'px';
    $('#drill-through-body').css('height', setTabulatorHeight);

    // Generate drill through table
    this.drillThroughGenerate();
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.Equipment-Expenses-Drill-Through-Main {
  font-size: 12px;
  padding: 5px 45px;
  display: flex;
  flex-direction: column; 

  > .drill-through-body {
    background-color: white;
    width: 100%;
    border-radius: 5px;
    padding: 5px;
    overflow: auto;
  }

  > .filtered-section {
    width: 100%;  
    height: auto;
    background-color: white;
    border-radius: 5px;
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 3px;

    > .filtered-items {
      width: calc(100% - 250px);

      > .filtered-row {
        display: flex;
        align-items: center;

        > .filter-title-long {
          width: 270px;
          padding-left: 3px;
        }

        > .filter-title {
          width: 120px;
          padding-left:3px;
        }

        > .colon-separator {
          margin: 0 5px;
        }

        > .filter-details {
          width: 100%;
        } 
      }
    }

    > .refresh-section {
      height: 100%;
      min-width: 250px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
      margin-right: 3px;
    }
  }
}

</style>